// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsCloudwatchLogGroupsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-cloudwatch-log-groups_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M27.63 24.12a3.5 3.5 0 0 0-3.52-3.45 3.5 3.5 0 0 0-3.52 3.45 3.5 3.5 0 0 0 3.52 3.46 3.5 3.5 0 0 0 3.52-3.46m1 0a4.5 4.5 0 0 1-4.52 4.44c-2.5 0-4.53-1.99-4.53-4.44a4.5 4.5 0 0 1 4.53-4.43c2.5 0 4.53 1.99 4.53 4.43m4.28 6.58-3.38-2.99q-.44.63-1.01 1.14l3.36 2.97c.32.28.8.25 1.09-.05a.75.75 0 0 0-.06-1.07m-8.8-1.15a5.5 5.5 0 0 0 5.53-5.43c0-2.99-2.48-5.42-5.53-5.42a5.5 5.5 0 0 0-5.54 5.42c0 3 2.49 5.43 5.54 5.43m9.48.42c.72.64.78 1.74.13 2.46a1.8 1.8 0 0 1-2.5.13l-3.5-3.1a6.6 6.6 0 0 1-3.61 1.08 6.5 6.5 0 0 1-6.54-6.42 6.5 6.5 0 0 1 6.54-6.4c3.6 0 6.54 2.87 6.54 6.4q-.02 1.47-.62 2.71zm-23-5.35h4.96v.98H10.6q-.84 0-1.79-.6A5.7 5.7 0 0 1 6 20.05c0-3.45 2.41-4.71 3.81-5.16l-.01-.49c0-2.8 1.94-5.71 4.51-6.76a7.7 7.7 0 0 1 8.53 1.64q1.1 1.06 1.79 2.56a3.4 3.4 0 0 1 2.17-.79c1.57 0 3.32 1.17 3.63 3.71 1.46.33 4.57 1.48 4.57 5.33q0 2.49-1.69 3.97l-.67-.74A4.1 4.1 0 0 0 34 20.08c0-3.39-2.88-4.23-4.13-4.43a.5.5 0 0 1-.33-.2.5.5 0 0 1-.08-.39c-.14-2.07-1.43-3.03-2.65-3.03-.75 0-1.46.36-1.94.99a.5.5 0 0 1-.48.2.5.5 0 0 1-.4-.33 8 8 0 0 0-1.85-2.92 6.7 6.7 0 0 0-7.43-1.43 6.7 6.7 0 0 0-3.9 5.85q0 .4.05.8a.5.5 0 0 1-.12.38.5.5 0 0 1-.3.16c-1.29.33-3.42 1.32-3.42 4.3 0 2.25 1.26 3.5 2.32 4.14q.72.44 1.26.45"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-cloudwatch-log-groups_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsCloudwatchLogGroups",
);
export default AwsCloudwatchLogGroupsIcon;
